import * as React from 'react';
import { useEffect } from 'react';
import { MessageTypes } from '../../core/enums';
import BottomModal from '../../commonComponents/bottomModal/BottomModal';
import { hasValue } from '../../lib/lib';
import { useMessageStore } from '../../zustandStore/messageStore';

const ScreenBottomMessageBar = () => {
	const { messageDetails, updateMessage } = useMessageStore();
	const { message, type } = messageDetails ?? { message: '', type: MessageTypes.Error };

	const [open, setOpen] = React.useState(hasValue(message));

	useEffect(() => {
		if (hasValue(message)) {
			setOpen(true);
		}
	}, [message]);

	const handleClick = () => {
		updateMessage(null, null);
		setOpen(false);
	};

	return (
		<BottomModal
			title="We've experienced an issue"
			body={typeof message === 'object' ? [concatMessages(message)] : [message]}
			open={open}
			onClose={handleClick}
			type={type}
		/>
	);
};

export default ScreenBottomMessageBar;

// Handle MVC ModelState errors
const concatMessages = (messageObject: unknown) => {
	if (!messageObject) return '';

	return Object.entries(messageObject)
		.map(([value]) => {
			if (Array.isArray(value)) {
				return value.join(' ');
			}
			return value;
		})
		.join(' ');
};
